import { count, sql } from "drizzle-orm";
import type { PowerSyncDrizzleDB } from "@space/powersync";

/**
 * Raw SQL query to get the number of pending changes in the PowerSync upload queue.
 * Used in Native where Drizzle might not be fully integrated for all components.
 */
export const UPLOAD_QUEUE_STATS_SQL = "SELECT count(*) as count FROM ps_crud" as const;

/**
 * Query to get the number of pending changes in the PowerSync upload queue.
 * Reused across Web and potentially Native (if using Drizzle).
 */
export function getUploadQueueStatsQuery(db: PowerSyncDrizzleDB) {
  return db.select({ count: count() }).from(sql`ps_crud`);
}
